/* import __COLOCATED_TEMPLATE__ from './bank-transfer.hbs'; */
import Component from '@glimmer/component';
import { formatNumber } from '@banking/ui/utils/checking/utils';
const ROUTING_NUMBER_INDICES = [6, 3];
const ACCOUNT_NUMBER_INDICES = [9, 6, 3];
export default class BankTransfer extends Component {
  get formattedAccountNumber() {
    return formatNumber(this.args.directDepositAccountData.accountNumber, ACCOUNT_NUMBER_INDICES);
  }
  get formattedRoutingNumber() {
    return formatNumber(this.args.directDepositAccountData.routingNumber, ROUTING_NUMBER_INDICES);
  }
}